import { useAuth } from "@/providers/auth";
import { ExclamationTriangleIcon, QuestionMarkCircledIcon } from "@radix-ui/react-icons";
import { Navigate, isRouteErrorResponse, useLocation, useRouteError } from "react-router-dom";
import { WretchError } from "wretch/resolver";
import AccessDenied from "./access-denied";

export default function AppError() {
    const { authenticated } = useAuth();
    const location = useLocation();
    const error = useRouteError();

    console.error(error);

    if (!authenticated) {
        return <Navigate to="/connexion" state={{ from: location }} replace />;
    }

    if (error instanceof WretchError || isRouteErrorResponse(error)) {
        if (error.status == 403) {
            return <AccessDenied />;
        } else if (error.status == 404) {
            return (
                <div className="p-5">
                    <div className="mx-auto max-w-[350px] rounded border p-5 text-center">
                        <div className="mb-2 flex items-center justify-center">
                            <QuestionMarkCircledIcon className="mr-2 h-5 w-5 text-blue-600" />
                            <h1 className="text-xl font-bold">Page not found</h1>
                        </div>
                        <h2 className="text-sm">The page you are trying to access does not exist (or you do not have the permission to access this record)</h2>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="p-5">
                    <div className="mx-auto max-w-[350px] rounded border p-5 text-center">
                        <div className="mb-2 flex items-center justify-center">
                            <ExclamationTriangleIcon className="mr-2 h-5 w-5 text-orange-600" />
                            <h1 className="text-xl font-bold">Oops</h1>
                        </div>
                        <h2 className="text-sm">An error occurred while accessing this page (Error {error.status})</h2>
                    </div>
                </div>
            );
        }
    } else {
        return (
            <div className="p-5">
                <div className="mx-auto max-w-[350px] rounded border p-5 text-center">
                    <div className="mb-2 flex items-center justify-center">
                        <ExclamationTriangleIcon className="mr-2 h-5 w-5 text-orange-600" />
                        <h1 className="text-xl font-bold">Oops</h1>
                    </div>
                    <h2 className="text-sm">An error occurred while accessing this page</h2>
                </div>
            </div>
        );
    }
}
